import {BaseEvent} from "./BaseEvent";

export class ShowSelectedDashboardEvent extends BaseEvent {
  public static NAME = 'showSelectedDashboard';

  constructor() {
    super(ShowSelectedDashboardEvent.NAME);
  }
}
